module.exports = __webpack_public_path__ + "static/media/teatro.7d4bddb1.svg";